import { Component, OnInit } from '@angular/core';
import { ErrorService } from '../../providers/error/error.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.page.html',
  styleUrls: ['./not-found.page.scss'],
})
export class NotFoundPage implements OnInit {

  constructor(private errorService: ErrorService) { }

  ngOnInit(): void {
    this.errorService.handleNotFound();
  }

}
